import { ApiProperty } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';

import { SpConnectOptionsValuesInterface } from '../interfaces/sp-connect-options-values.interface';

export class SpConnectOptionsValuesDto
  implements SpConnectOptionsValuesInterface
{
  @ApiProperty()
  @IsOptional()
  name?: string;

  @ApiProperty()
  @IsOptional()
  description?: string;
}
